
export const galeryObj = [
    {
      original: "/images/marker1.jpg",
      thumbnail: "/images/marker1.jpg"
    },
    {
      original: "/images/marker2.jpg",
      thumbnail: "/images/marker2.jpg"
    },
    {
      original: "/images/marker3.jpg",
      thumbnail: "/images/marker3.jpg"
    },
    {
        original: "/images/marker4.jpg",
        thumbnail: "/images/marker4.jpg"
    },
    {
        original: "/images/marker5.jpg",
        thumbnail: "/images/marker5.jpg"
    },
    {
        original: "/images/marker6.jpg",
        thumbnail: "/images/marker6.jpg"
    },
    {
        original: "/images/marker7.jpg",
        thumbnail: "/images/marker7.jpg"
    },
    {
        original: "/images/marker8.jpg",
        thumbnail: "/images/marker8.jpg"
    },
    {
        original: "/images/marker9.jpg",
        thumbnail: "/images/marker9.jpg"
    },
    {
        original: "/images/marker10.jpg",
        thumbnail: "/images/marker10.jpg"
    },
    {
        original: "/images/marker11.jpg",
        thumbnail: "/images/marker11.jpg"
    },
    {
        original: "/images/marker12.jpg",
        thumbnail: "/images/marker12.jpg"
    },
 
 

  ];
  
export const galeryObj2 = [
    {
      original: "/images/game1.jpg",
      thumbnail: "/images/game1.jpg"
    },
    {
      original: "/images/game2.jpg",
      thumbnail: "/images/game2.jpg"
    },
    {
      original: "/images/game3.jpg",
      thumbnail: "/images/game3.jpg"
    },
    {
        original: "/images/game4.jpg",
        thumbnail: "/images/game4.jpg"
    },
    {
        original: "/images/game5.jpg",
        thumbnail: "/images/game5.jpg"
    },
   
    {
        original: "/images/game7.jpg",
        thumbnail: "/images/game7.jpg"
    },
    {
        original: "/images/game8.jpg",
        thumbnail: "/images/game8.jpg"
    },
    {
        original: "/images/game9.jpg",
        thumbnail: "/images/game9.jpg"
    },
 

  ];